import type { User } from '@metadevprofile/shared';
import { institutionApi, profileApi } from '@metadevprofile/shared/api';
import { store } from '@/common/redux/store';

export const hydrateUser = async (user: User): Promise<void> => {
  if (!user.has_profile) return;

  // Warms the RTK Query cache so the first component reading `useGetProfileQuery`/
  // `useGetInstitutionQuery` (AuthGuard, Footer, ...) doesn't have to wait on its own fetch.
  const tasks: Promise<unknown>[] = [store.dispatch(profileApi.endpoints.getProfile.initiate())];
  if (user.institution_id) {
    tasks.push(store.dispatch(institutionApi.endpoints.getInstitution.initiate()));
  }

  await Promise.all(tasks);
};
